import { render, staticRenderFns } from "./PlayerTransferStart.vue?vue&type=template&id=c192c8d4&scoped=true&"
import script from "./PlayerTransferStart.vue?vue&type=script&lang=js&"
export * from "./PlayerTransferStart.vue?vue&type=script&lang=js&"
import style0 from "./PlayerTransferStart.vue?vue&type=style&index=0&id=c192c8d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c192c8d4",
  null
  
)

export default component.exports